// extracted by mini-css-extract-plugin
export var hideButtons = "Reviews-module--hideButtons--c2d0b";
export var label = "Reviews-module--label--2c453";
export var list = "Reviews-module--list--fe2d7";
export var listContainer = "Reviews-module--listContainer--19fb5";
export var reviews = "Reviews-module--reviews--bc297";